import styled from 'styled-components';

export const LayoutFilterProducts = styled.div`
  margin-top: var(--spacing-margin-small);
  margin: 0 auto;
  width: 100%;
  position: relative;
  .breadcrumbs-container {
    padding-bottom: 16px;
    border-bottom: 1px solid #dedede;
    width: 100%;
  }
  .banners-container {
    margin-top: 16px;
  }
  .grid-content {
    display: grid;
    gap: 0 8px;
    grid-template-columns: ${({ isMobile }) =>
      isMobile ? 'none' : '320px 1fr'};
  }
`;

export const ProductsHeaderStyles = styled.div`
  display: flex;
  margin: var(--spacing-margin-small) 0px;
`;

export const ProductsContainer = styled.div`
  margin-top: var(--spacing-margin-small);
`;
